import { useEffect } from 'react';

/**
 * Хук для ресайза превью скрипта
 */
const usePanelResize = ({ ref, callback }) => {
  const resize = (e) => {
    callback(e.clientX);
  };

  const stopResize = () => {
    document.removeEventListener('mousemove', resize, false);
    document.removeEventListener('mouseup', stopResize, false);
  };

  const initResize = () => {
    document.addEventListener('mousemove', resize, false);
    document.addEventListener('mouseup', stopResize, false);
  };

  useEffect(() => {
    if (ref.current) {
      ref.current.addEventListener('mousedown', initResize, false);
    }
    return () => {
      if (ref.current) {
        ref.current.removeEventListener('mousedown', initResize, false);
      }
    };
  }, []);
};

export default usePanelResize;
